package com.downdogapp.client.views.playback

import com.downdogapp.*
import com.downdogapp.Display.INLINE_BLOCK
import com.downdogapp.Position.ABSOLUTE
import com.downdogapp.Position.RELATIVE
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.Size.INHERIT
import com.downdogapp.TextAlign.CENTER
import com.downdogapp.client.AbstractView
import com.downdogapp.client.widget.RangeSlider
import com.downdogapp.client.widget.RangeSlider.Companion.rangeSlider
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement

class TimelineSlider(valueRange: DoubleRange,
                     startValue: Double,
                     onMouseDown: RangeSlider.() -> Unit,
                     onValueChanged: RangeSlider.() -> Unit,
                     onMouseUp: RangeSlider.() -> Unit) : AbstractView(), RangeSlider {

  private var beforePlaybackHead: HTMLDivElement
  private var afterPlaybackHead: HTMLDivElement
  private val slider: RangeSlider

  override val root = createDiv {
    position = RELATIVE
    width = INHERIT
    height = px(15)

    div {
      position = ABSOLUTE
      top = px(6)
      left = px(0)
      width = percent(100)
      height = px(15)

      textAlign = CENTER

      beforePlaybackHead = div {
        height = px(5)
        width = percent(50)
        display = INLINE_BLOCK
        bgColor = Color.DOWN_DOG_BLUE
      }
      afterPlaybackHead = div {
        height = px(5)
        width = percent(50)
        display = INLINE_BLOCK

        bgColor = Color.grey(0.4)
      }
    }
    div {
      position = ABSOLUTE
      top = px(0)
      left = px(0)
      width = percent(100)
      height = px(15)

      slider = rangeSlider(
        valueRange = valueRange,
        startValue = startValue,
        className = "timeline-slider",
        onMouseUp = onMouseUp,
        onValueChanged = {
          onValueChanged()
          // TODO:  Need less brittle fix for this
          val before =
            proportion +
            if (proportion < 0.3) 0.005 else 0.0 // Adjust for inconsistency in width between colored divs and input range
          beforePlaybackHead.width = percent(100 * before)
          afterPlaybackHead.width = percent(100 * (1 - before))
        },
        onMouseDown = onMouseDown
      ) {
        opacity = 0.0
      }
    }
  }

  override var proportion: Double
    get() = slider.proportion
    set(proportion) {
      slider.proportion = proportion
    }

  override var value: Double
    get() = slider.value
    set(value) {
      slider.value = value
    }

  override fun setValueNoUpdate(value: Double) {
    slider.setValueNoUpdate(value)
  }
}

fun HTMLElement.timelineSlider(valueRange: DoubleRange,
                               startValue: Double = 0.0,
                               onMouseDown: RangeSlider.() -> Unit = {},
                               onValueChanged: RangeSlider.() -> Unit = {},
                               onMouseUp: RangeSlider.() -> Unit = {},
                               init: HTMLDivElement.() -> Unit = {}): TimelineSlider {
  val view = TimelineSlider(valueRange, startValue, onMouseDown, onValueChanged, onMouseUp)
  append(view.root)
  view.root.apply(init)
  return view
}
